import { useSettingsStore } from '@/store';
import { Colors } from '@/types/appConfigTypes';

// Define default colors for fallback
const defaultColors: Colors = {
  primary: {
    light: '#3E64FF',
    dark: '#3E64FF',
    foregroundLight: '#FFFFFF',
    foregroundDark: '#FFFFFF',
  },
  secondary: {
    light: '#3E64FF',
    dark: '#3E64FF',
    foregroundLight: '#FFFFFF',
    foregroundDark: '#FFFFFF',
  }
};

const useColors = () => {
  const { settings, themeMode = 'light' } = useSettingsStore();
  
  // Get colors from settings or use defaults
  const colors = settings?.ui?.theming?.colors || defaultColors;

  // Get appropriate colors based on theme
  const primaryColor = colors.primary?.[themeMode as 'light' | 'dark'] || defaultColors.primary.light;
  const secondaryColor = colors.secondary?.[themeMode as 'light' | 'dark'] || defaultColors.secondary.light;
  
  const primaryForegroundColor = themeMode === 'light' 
    ? colors.primary?.foregroundLight || defaultColors.primary.foregroundLight
    : colors.primary?.foregroundDark || defaultColors.primary.foregroundDark;
    
  const secondaryForegroundColor = themeMode === 'light'
    ? colors.secondary?.foregroundLight || defaultColors.secondary.foregroundLight
    : colors.secondary?.foregroundDark || defaultColors.secondary.foregroundDark;

  return {
    primaryColor,
    secondaryColor,
    primaryForegroundColor,
    secondaryForegroundColor,
  };
};

export default useColors;
